export default "__VITE_ASSET__0bd04394__"